<template>
    <nav class="relative">
        <div
            :class="[{ 'btn-close': showMenu }, 'btn relative']"
            @click="showMenu = !showMenu">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div
            :class="[
                { 'active-mobile-nav': showMenu },
                'custom-mobile-nav overflow',
            ]">
            <ul class="">
                <li
                    v-for="(item, index) in navList"
                    :key="index"
                    :class="[
                        { 'li-active': index === activeNum },
                        'transition',
                    ]"
                    @click="navigateToTarget(item.name, index)">
                    {{ item.title }}
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
export default {
    name: "customMobileNav",
    props: {
        navList: {
            type: Array,
            default: () => [],
        },
        activeNum: {
            type: [String, Number],
            default: 0,
        },
    },
    data() {
        return {
            showMenu: false,
        };
    },
    methods: {
        navigateToTarget(name, index) {
            this.showMenu = false;
            window.sessionStorage.setItem("nav", index);
            this.$emit("update:activeNum", index);
            this.$router.push({ name });
        },
    },
};
</script>

<style lang="scss" scoped>
nav {
    display: flex;
    justify-content: flex-end;
    width: 100vw;
}
.btn {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 1.2rem;
    margin: 0.4rem;
    z-index: 2;
    transition-property: border-radius background-color border;
    transition-duration: 0.3s;
    border: 0.26rem solid transparent;
    border-radius: 0.2rem;
    background-color: rgba($color: #000000, $alpha: 0.4);
    span {
        display: block;
        width: 1.2rem;
        height: 0.12rem;
        background-color: #fff;
        transition-property: opacity transform top background-color;
        transition-duration: 0.3s;
        &:nth-child(2) {
            transition-duration: 0.1s;
        }
    }
}
.btn-close {
    position: relative;
    background-color: #2cde00;
    border-radius: 50%;
    border: 0.26rem solid #2cde00;
    span {
        &:nth-child(1) {
            position: absolute;
            transform: rotateZ(45deg);
            top: 0.6rem;
        }
        &:nth-child(2) {
            opacity: 0;
        }
        &:nth-child(3) {
            position: absolute;
            transform: rotateZ(-45deg);
            top: 0.6rem;
        }
    }
}
.custom-mobile-nav {
    height: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    transition-property: background-color height;
    transition-duration: 0.3s;
}
.active-mobile-nav {
    height: 100vh;
    background-color: rgba($color: #fff, $alpha: 0.97);
}
ul {
    width: 100vw;
    padding: 0.4rem;
    padding-top: 2.4rem;
    box-sizing: border-box;
}
li {
    padding: 0.8rem;
    font-size: 0.8rem;
    text-align: center;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    &:last-of-type {
        border-bottom-color: transparent;
    }
}
.li-active {
    color: #2cde00;
}
</style>
